import { createBrowserRouter } from 'react-router-dom'
import ErrorPage from '../pages/ErrorPage.tsx'

export const router = createBrowserRouter([
  {
    path: '/login',
    id: 'login',
    lazy: async () => {
      const Login = await import('../pages/Login.tsx')
      return {
        Component: Login.default
      }
    }
  },
  {
    lazy: async () => {
      const PrivateRouter = await import('./PrivateRouter.tsx')
      return {
        Component: PrivateRouter.default
      }
    },
    ErrorBoundary: ErrorPage,
    children: [
      {
        lazy: async () => {
          const Layout = await import('../components/Layout.tsx')
          return {
            Component: Layout.default
          }
        },
        children: [
          {
            path: '/',
            id: 'home',
            lazy: async () => {
              const Home = await import('../pages/Home.tsx')
              return {
                Component: Home.default
              }
            }
          },
          {
            path: '/inbox',
            id: 'inbox',
            lazy: async () => {
              const Inbox = await import('../pages/Inbox.tsx')
              return {
                Component: Inbox.default
              }
            }
          },
          {
            path: '/search',
            id: 'search',
            lazy: async () => {
              const Tickets = await import('../pages/Search.tsx')
              return {
                Component: Tickets.default
              }
            }
          },
          {
            path: '/search/:ticketId',
            id: 'search-ticket',
            lazy: async () => {
              const TicketDetail = await import('../pages/TicketDetail.tsx')
              return {
                Component: TicketDetail.default
              }
            }
          },
          {
            path: '/settings',
            id: 'settings',
            lazy: async () => {
              const Settings = await import('../pages/Settings.tsx')
              return {
                Component: Settings.default
              }
            }
          },
          {
            path: '/anec-users',
            id: 'anec-users',
            lazy: async () => {
              const AnecUsers = await import('../pages/AnecUsers.tsx')
              return {
                Component: AnecUsers.default
              }
            }
          }
        ]
      }
    ]
  }
])
